import React, { Component } from 'react';
import { Banner } from '../../Components'
import profile from './profile.jpg'
import './Update.scss'
import {Helmet} from "react-helmet"

import { observable } from 'mobx'
import { observer, inject } from 'mobx-react'
@inject("store")
@observer  
class Update extends Component {

    @observable failed = false

    handleClick = () => {
        this.props.store.api.post('/update/doctor', { hodby_id: this.props.store.username, hodby_password: this.props.store.password })
            .then(({ data }) => {
                localStorage.setItem("update_username", JSON.stringify(this.props.store.username))
                localStorage.setItem("update_password", JSON.stringify(this.props.store.password))
                localStorage.setItem("update_doctor", JSON.stringify(data))
                this.props.store.doctor = data
                this.props.history.push('/update/view')
            })
            .catch(err => { console.log(err);this.failed = true})
    }

    



    render() {

        
        return (
            <div>
				<Helmet>
					<title>Update Listing | GPbook</title>
				</Helmet>	
                 <Banner title="Update Specialist Details" subtitle="Check if your details are current, and update your record." />

                 <div className="container page">
                    <div className="row">
                        
                        <div className="col-md-6">
                        <h1 style={{marginBottom:12,}}>Specialist Annual Details Update</h1>
                        <p style={{marginBottom:12,}}>Your details in the Medical & Surgical Specialist Referral Directory and GPbook may be out of date.
                        </p>  <p>
                                Please update your specialist profile below. Please log in with the details you would have received by fax or email to your account, where you will be able to update your specialist record in both the online and physical directories. Use your <u>Reference ID</u> and <u>Password</u> to login to your account. </p>
                            
                        <a href="https://online.gpbook.com.au/update">
                                <div className="btn m-t-1">Click here to update listing</div>
                        </a>

                        {/* <div className="login-box">
                                <h3 className="secondary">Login to your account</h3>
                            <div className="row">
                                <div className="col-md-6">
                                    <h4 style={{marginBottom:12,marginTop:12}}>Reference ID</h4>
                                    <input name="hodby_id" type="text" placeholder="SMITH,JOH" className="input" autoComplete={false} value={this.props.store.username} onChange={e=>this.props.store.username = e.target.value} />
                                </div>
                                <div className="col-md-6">
                                    <h4 style={{marginBottom:12,marginTop:12}}>Password</h4>
                                    <input name="hodby_password" type="password" placeholder="******" className="input" value={this.props.store.password} autoComplete={false} onChange={e=>this.props.store.password = e.target.value} />
                                </div>
                            </div>  
                            <div className="btn secondary" style={{ marginTop: 12 }} onClick={this.handleClick}>Login</div> 
								{this.failed && <div className="text-secondary m-t-1">Incorrect username or password, please try again</div>}  

								<p className="text-secondary m-t-1">
									Updates for the current paper edition are now closed. However your submissions will be included in the online directory and in the next paper edition.
								</p>	
                        </div>  */}

                        <div style={{marginTop:12,}}><b >Please update the following details</b>   </div> 
                        <ul>
                            <li>Contact Details</li>
                            <li>Speciality</li>        
                            <li>Special Interests</li>        
                            <li>Clinics</li>        
                            <li>Hospitals</li>        
                            <li>Qualifications</li>        
                            <li>Avatar</li>        
                        </ul>    
                            
                        


                        <p style={{marginTop:12,}}>
                            If you have not received your fax or email, or believe you may not be in the directory, you can email us at <a href="mailto:info@gpbook.com.au">info@gpbook.com.au</a> to confirm.
                        </p>    

                        </div>
                        <div className="col-md-6">
                            <img src={profile} alt="Profile" width="100%" />
                        </div>
                       
                    </div>
                    
                 </div>
                
            </div>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/Containers/Update/Update.js